type NavigationType = {
	to: string | string[];
	itemTitle: string;
	does: string[];
	defaultToDoes?: string;
	premium?: boolean;
	dropDown?: {
		to: string;
		itemTitle: string;
		does: string[];
		premium?: boolean;
	}[];
};

export const Navigation: NavigationType[] = [
	{
		to: '/home',
		itemTitle: 'Accueil',
		does: ['true'],
	},
	{
		to: ['/clients', '/contacts'],
		itemTitle: 'Clients',
		does: ['get_clients', 'get_contacts'],
		dropDown: [
			{
				to: '/clients',
				itemTitle: 'Clients',
				does: ['get_clients'],
			},
			{
				to: '/contacts',
				itemTitle: 'Contacts',
				does: ['get_contacts'],
			},
		],
	},
	{
		to: '/fournisseurs',
		itemTitle: 'Fournisseurs',
		does: ['get_suppliers'],
		premium: true,
	},
	{
		defaultToDoes: 'get_sobrus_products',
		to: ['/produits', '/quotas'],
		itemTitle: 'Produits',
		does: ['get_sobrus_products', 'get_client_sales_quotas'],
		dropDown: [
			{
				to: '/produits',
				itemTitle: 'Produits',
				does: ['get_sobrus_products'],
			},
			{
				to: '/quotas',
				itemTitle: 'Quotas',
				does: ['get_client_sales_quotas'],
				premium: true,
			},
		],
	},
	{
		defaultToDoes: 'get_client_orders',
		to: [
			'/ventes/offers',
			'/ventes/quotation',
			'/ventes/commandes-clients',
			'/ventes/bon-de-livraison',
			'/ventes/facture-client',
			'/ventes/payments',
			'/ventes/avoirs-client',
			'/ventes/bon-de-retour',
		],
		itemTitle: 'Ventes',
		does: [
			'get_offers_list',
			'app_client_pricingget_client_pricing_list',
			'get_client_orders',
			'get_all_client_delivery_notes',
			'get_client_dispatch_notes_list',
			'get_all_client_invoices',
			'get_all_client_issued_return',
			'get_all_client_received_return',
			'get_all_deposit_slips',
		],
		dropDown: [
			{
				to: '/ventes/offers',
				itemTitle: 'Offres',
				does: ['get_offers_list'],
			},
			{
				to: '/ventes/quotation',
				itemTitle: 'Devis',
				does: ['app_client_pricingget_client_pricing_list'],
				premium: true,
			},
			{
				to: '/ventes/commandes-clients',
				itemTitle: 'Commandes clients',
				does: ['get_client_orders'],
			},
			{
				to: '/ventes/bon-de-livraison',
				itemTitle: 'Bons de livraison',
				does: ['get_all_client_delivery_notes'],
				premium: true,
			},
			{
				to: '/ventes/bordereaux',
				itemTitle: "Bordereaux d'expédition",
				does: ['get_client_dispatch_notes_list'],
				premium: true,
			},
			{
				to: '/ventes/avoirs-client',
				itemTitle: 'Avoirs clients',
				does: ['get_all_client_issued_return'],
				premium: true,
			},
			{
				to: '/ventes/facture-client',
				itemTitle: 'Factures',
				does: ['get_all_client_invoices'],
				premium: true,
			},
			{
				to: '/ventes/payments',
				itemTitle: 'Paiements',
				does: ['get_all_client_payments'],
				premium: true,
			},
			{
				to: '/ventes/bordereaux-cheque',
				itemTitle: 'Bordereaux de chèques',
				does: ['get_all_deposit_slips'],
				premium: true,
			},
			// {
			// 	to: '/ventes/bon-de-retour',
			// 	itemTitle: 'Bons de retour',
			// 	does: ['get_all_client_received_return'],
			// 	premium: true,
			// },
		],
	},
	{
		defaultToDoes: 'get_supplier_purchase_order',
		to: [
			'/achats/offers',
			'/achats/marketplace-commande',
			'/achats/proposition-commande',
			'/achats/bons-de-commande',
			'/achats/bons-de-reception',
			'/achats/factures-fournisseur',
			'/achats/avoir-emis',
			'/achats/bons-de-sortie',
			'/achats/avoir-recu',
			'/achats/expenses',
		],
		itemTitle: 'Achats',
		does: [
			'get_wholesaler_offers_list',
			'get_marketplace_orders_list',
			'get_all_supplier_purchase_suggestion',
			'get_supplier_purchase_order',
			'get_all_supplierdeliverynotes',
			'get_supplier_invoice',
			'get_all_supplier_issued_return',
			'get_all_supplier_received_return',
			'get_release_voucher',
			'',
		],
		premium: true,
		dropDown: [
			{
				to: '/achats/offers',
				itemTitle: 'Offres',
				does: ['get_wholesaler_offers_list'],
				premium: true,
			},
			{
				to: '/achats/marketplace-commande',
				itemTitle: 'Commandes Marketplace',
				does: ['get_marketplace_orders_list'],
				premium: true,
			},
			{
				to: '/achats/proposition-commande',
				itemTitle: 'Propositions de commande',
				does: ['get_all_supplier_purchase_suggestion'],
				premium: true,
			},
			{
				to: '/achats/demande-prix',
				itemTitle: 'Demandes de prix',
				does: ['get_supplier_price_request_list'],
				premium: true,
			},
			{
				to: '/achats/bons-de-commande',
				itemTitle: 'Bons de commande',
				does: ['get_supplier_purchase_order'],
				premium: true,
			},
			{
				to: '/achats/bons-de-reception',
				itemTitle: 'Bons de réception',
				does: ['get_all_supplierdeliverynotes'],
				premium: true,
			},
			{
				to: '/achats/factures-fournisseur',
				itemTitle: 'Factures fournisseurs',
				does: ['get_supplier_invoice'],
				premium: true,
			},
			{
				to: '/achats/avoir-emis',
				itemTitle: 'Avoirs fournisseurs émis',
				does: ['get_all_supplier_issued_return'],
				premium: true,
			},
			{
				to: '/achats/bons-de-sortie',
				itemTitle: 'Bons de sortie',
				does: ['get_release_voucher'],
				premium: true,
			},
			{
				to: '/achats/avoir-recu',
				itemTitle: 'Avoirs fournisseurs reçus',
				does: ['get_all_supplier_received_return'],
				premium: true,
			},
			{
				to: '/achats/expenses',
				itemTitle: 'Dépenses',
				does: [''],
				premium: true,
			},
		],
	},
	{
		to: ['/exchanges/colleagues', '/exchanges/colleagues-sales', '/exchanges/colleagues-purchases'],
		itemTitle: 'Echanges',
		premium: true,
		// TODO: ADD ACL TO NAVIGATION
		does: ['get_colleagues'],
		dropDown: [
			{
				to: '/exchanges/colleagues',
				itemTitle: 'Confrères',
				does: ['get_colleagues'],
				premium: true,
			},
			{
				to: '/exchanges/colleagues-purchases',
				itemTitle: 'Entrées confrères',
				does: ['get_colleagues_purchases'],
				premium: true,
			},
			{
				to: '/exchanges/colleagues-sales',
				itemTitle: 'Sorties confrères',
				does: ['get_colleagues_sales'],
				premium: true,
			},
		],
	},
	{
		to: '/requests',
		itemTitle: 'Demandes',
		does: ['get_all_demands'],
		premium: true,
	},
	{
		to: '/loyalty-programs',
		itemTitle: 'Fidélisation',
		does: ['get_list_of_loyalty_programs_with_filters_and_pagination'],
		premium: true,
		dropDown: [
			{
				to: '/loyalty-programs',
				itemTitle: 'Programme',
				does: ['get_list_of_loyalty_programs_with_filters_and_pagination'],
				premium: true,
			},
		],
	},
	{
		to: '/marketing/campaigns',
		itemTitle: 'Marketing',
		does: ['list_publications'],
		dropDown: [
			{
				to: '/marketing/campaigns',
				itemTitle: 'Publications',
				does: ['list_publications'],
			},
			{
				to: '/marketing/labo-space',
				itemTitle: 'Espace labo',
				does: ['true'],
			},
			{
				to: '/espace-events',
				itemTitle: 'Évènements',
				does: ['true'],
			},
		],
	},
	{
		to: ['/stock', '/inventaires'],
		itemTitle: 'Stock',
		does: ['get_stocks', 'get_inventories_list'],
		premium: true,
		dropDown: [
			{
				to: '/stock',
				itemTitle: 'Stock',
				does: ['get_stocks'],
				premium: true,
			},
			{
				to: '/inventaires',
				itemTitle: 'Inventaires',
				does: ['get_inventories_list'],
				premium: true,
			},
		],
	},
	{
		to: '/transferts-entrepot',
		itemTitle: 'Transferts d’entrepôt',
		does: ['get_all_stock_transfers'],
		premium: true,
	},
	{
		to: '/parc-auto',
		itemTitle: 'Parc auto',
		does: ['get_vehicles'],
		premium: true,
	},
	// {
	//     to: "/logs-erreurs",
	//     itemTitle: " Logs d'erreurs",
	//     does: ["get_all_log"],
	// },

	{
		to: '/reports',
		itemTitle: 'Rapports',
		does: [
			'get_sales_reports',
			'get_purchases_reports',
			'get_clients_reports',
			'get_turnovers_online_order_reports_by_status',
			'get_turnovers_online_order_reports_by_client',
			'get_turnovers_online_order_reports_by_product',
			'get_online_order_errors_report',
			'get_online_order_product_quatities_gap_report',
			'get_marketplace_report',
			'get_reedited_client_delivery_notes_report',
			'get_stocks_report',
			'get_sales_delivery_zones_reports',
			'get_sales_suppliers_reports',
			'get_sales_clients_reports',
			'get_sales_products_reports',
			'get_sales_client_delivery_notes_reports',
			'get_client_payments_reports',
			'get_product_transactions_report',
		],
	},
	{
		to: '/settings',
		itemTitle: 'Paramètres',
		does: ['true'],
	},
];
